import { ContextStore } from '../../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../../react-core/Async/Promise';
import { InvestmentDetailsCollectionModel } from '../../../Models/Domains/Transfer/InvestmentDetailsCollectionModel';

declare var IS_RUNNING_IN_APP_POOL;

export class ProductInvestmentDetailsClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(hierarchyId: string): Promise<InvestmentDetailsCollectionModel, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Transfer/ProductInvestmentDetails/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { hierarchyId: hierarchyId }

    return AjaxWrapper.get<InvestmentDetailsCollectionModel, any>(url, data);
  }
}

